<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>UMOWA ZLECENIE [nrUmowy]</strong>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, o kapitale
  zakładowym w wysokości 1 664 600,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>[zamawiajacy]</strong>,
</p>
<p>a</p>
<p>
  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko: [imieNazwisko]
  <br/>
  Pesel: [pesel]
  <br/>
  Adres: [zamieszkany]
  <br/>
  <br/>
  <strong>Okres trwania umowy i okres wypowiedzenia:</strong>
  <br>
  Okres trwania umowy: <strong> od [datapocz] r. do [datakon] r. </strong>
  <br>
  Okres wypowiedzenia: <strong> [okresWypowiedzenia] </strong> 
  <br/>
  <p><strong>Wynagrodzenie:</strong></p>
  Kwota brutto:<strong> [kwota] PLN /godzinę</strong>
  <br>
  <br>
  <p align="center"><strong>Warunki umowy</strong></p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p>Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
</p>
<ol type="a">
  <li>obsługa telefonicznego biura obsługi klienta Zleceniodawcy,</li>
  <li>udzielanie informacji w zakresie oferowanych przez Zleceniodawcę usług i produktów,</li>
  <li>świadczenie pomocy w korzystaniu z produktów bądź usług oferowanych przez Zleceniodawcę,</li>
  <li>przyjmowanie od klientów Zleceniodawcy telefonicznych zleceń i reklamacji,</li>
  <li>przeprowadzanie telefonicznej kampanii marketingowej,</li>
  <li>przeprowadzanie sondaży telefonicznych.</li>
</ol>
<br>
<p>Zleceniobiorca będzie wykonywał Zlecenie w siedzibie Zleceniodawcy wg grafików obecności ustalanych z wyprzedzeniem.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Zastępca</strong>
</p>
<ol>
  <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
  <li>Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.<span class="pageNum" style="margin-top: 35px;">1 z 11</span></li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3 Obowiązek informacyjny</strong>
</p>
  <ol>
    <li>Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy.
</li>
    <li>Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4 Realizacja przedmiotu zlecenia</strong>
</p>
<ol>
  <li>Strony ustalają wspólnie, iż Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością, tj.:
    <br>
    <ol type="a">
      <li>rzetelnie i dokładnie udzielać informacji klientom w zakresie oferowanych przez Zleceniodawcę usług i produktów, jak również ustawiać poprawne statusy w systemie CRM niezwłocznie po zakończeniu rozmowy z klientem,</li>
      <li>przestrzegać określonych przez Zleceniodawcę wytycznych prowadzenia rozmowy telefonicznej z klientem,</li>
      <li>rozłączać pocztę głosową bezpośrednio po rozpoczęciu nagrania,</li>
      <li>rzetelnie i dokładnie ewidencjonować godziny wykonywania zlecenia w udostępnionym zestawieniu, o którym mowa w § 5 ust.2,</li>
      <li>udzielać informacji osobie wskazanej przez Zleceniodawcę o niezakończonych zadaniach w ramach realizacji przedmiotu zlecenia w danym dniu,</li>
      <li>nie korzystać z prywatnego telefonu podczas ustalonej dyspozycyjności, z wyłączeniem przerw.</li>
    </ol>
  </li>
  <li>Zleceniobiorca zobowiązuje się do dbania o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia, w tym nie spożywać posiłków podczas rozmów telefonicznych z klientem Zleceniodawcy (posiłki są spożywane tylko w wyznaczonych miejscach biura Zleceniodawcy).</li>
  <li>W ramach ustalonej przez obie strony dyspozycyjności Zleceniobiorca realizuje powierzone czynności w określonych godzinach, uwzględniając w tym czasie przerwy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5 Termin i sposób zapłaty wynagrodzenia </strong>
</p>
<ol>
  <li>Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, do 15-tego dnia następnego miesiąca, w wysokości wynikającej ze stawki godzinowej oraz liczby godzin przepracowanych w danym miesiącu, w oparciu o zestawienie, o którym mowa w ust. 2 poniżej.</li>
  <li>Zleceniobiorca jest obowiązany do przygotowania i przedłożenia Zleceniodawcy w formie elektronicznej zestawienia liczby godzin przepracowanych w danym miesiącu najpóźniej w pierwszym dniu roboczym następnego miesiąca. Zweryfikowane przez Zleceniodawcę zestawienie będzie stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6 Premia i benefity</strong>
  </p>
<ol>
  <li>Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową za wyniki osiągnięte w ramach wykonanego zlecenia. Premia jest naliczana w wysokości do 132 zł brutto za każdy tydzień realizacji zlecenia (maksymalnie 528 zł brutto za miesiąc). Wysokość jest uzależniona od stopnia realizacji określonych celów indywidualnych przez zleceniobiorcę oraz od jakości prowadzonych rozmów telefonicznych zgodnie z określonymi wytycznymi przez Zleceniodawcę. Ocena jakości rozmów będzie dokonywana na podstawie monitoringu rozmów telefonicznych prowadzonych przez Zleceniobiorcę.</li>
  <li>Zleceniodawca zastrzega sobie prawo do zmiany wysokości premii w zależności od zadań aktualnie realizowanych przez Zleceniobiorcę. Zadania indywidualne na kolejny tydzień będą przedstawiane z odpowiednim wyprzedzeniem.</li>
  <li>Dodatkowo Zleceniodawca może przyznać  premię uznaniową w przypadku realizacji zlecenia w wyższym tygodniowym wymiarze godzin tj.:
    <br>
    <ol type="a">
      <li>od 34 do 39 godzin w danym tygodniu wynosi 15 zł brutto za tydzień realizacji zlecenia (maksymalnie 60 zł brutto za miesiąc),</li>
    <li>od 40 lub więcej godzin w danym tygodniu wynosi 25 brutto za tydzień realizacji zlecenia (maksymalnie 100 zł brutto za miesiąc).<span class="pageNum" style="margin-top: 9px;">2 z 11</span></li>
    </ol>
  </li>
  <li>W przypadku niestosowania się do postanowień wskazanych w § 4 jak również udzielania błędnych informacji klientom, Zleceniodawca może obniżyć ww. premie w zależności od ilości upomnień przekazywanych Zleceniobiorcy tj. w przypadku:
  <br>
  <ol type="a">
    <li>jednokrotnego ostrzeżenia premia tygodniowa zostanie obniżona o 20%,</li>
    <li>kolejnego ostrzeżenia premia tygodniowa zostanie obniżona o 100%,</li>
    <li>gdy Zleceniobiorca w danym miesiącu będzie miał dwukrotnie obniżoną premię tygodniową o 100%, premia za cały miesiąc zostanie obniżona o 100%.</li>
  </ol>
</li>
<li>Zleceniobiorca w trakcie trwania umowy zlecenie ma możliwość zakupu usługi dostępu do obiektów sportowo-rekreacyjnych po cenach niższych niż detaliczne ceny rynkowe. Zleceniodawca finansuje część tego świadczenia. Szczegółowe warunki finansowania świadczeń przez Zleceniodawcę zostaną ogłoszone przez Zleceniodawcę elektronicznie w formie wiadomości mailowej.</li>
<li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego.</li>
<li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7 Klauzula poufności</strong>
</p>
<ol>
  <li>Strony, w związku z zawarciem niniejszej umowy zobowiązane są zapewnić należytą ochronę informacji poufnych przekazanych sobie dla potrzeb realizacji niniejszej umowy, w szczególności poprzez odebranie od podmiotów trzecich stosownych oświadczeń woli.</li>
  <li>Za poufne Strony uznają w szczególności materiały, dokumenty i informacje dotyczące kwestii:
    <br>
    <ol type="a">
      <li>finansowych,</li>
      <li>technicznych,</li>
      <li>handlowych,</li>
      <li>know – how,</li>
      <li>koncepcji,</li>
      <li>strategii,</li>
      <li>źródeł i sposobów finansowania.</li>
      <br>
    </ol>
    <p>Za poufne Strony nie uznają w szczególności materiałów, dokumentów i informacji, które:</p>
    <ol type="a">
    <li>w dacie ich ujawnienia stanowią informacje dostępne publicznie,</li>
    <li>są już w dacie podpisania niniejszej umowy znane Stronom i wiedza ta została nabyta zgodnie z prawem, w sposób niezwiązany z realizacją przedmiotu niniejszej umowy,</li>
    <li>zostały po zawarciu niniejszej umowy pozyskane przez Stronę od podmiotów trzecich, które z kolei nie pozyskały takiej informacji bezpośrednio lub pośrednio od drugiej Strony i nie naruszyły w inny sposób jakiegokolwiek zobowiązania poufności.</li>
    </ol>
  </li>
<li>Zleceniobiorca zobowiązuje się zachować w tajemnicy wszelkie niewymienione w ust. 2 informacje, których ujawnienie mogłoby narazić Zleceniodawcę na szkodę.</li>
<li>W przypadku gdy Strona, zgodnie z ogólnie obowiązującymi przepisami prawa, w szczególności na wezwanie organów działających w granicach swoich uprawnień ujawni informacje poufne przekazane jej przez drugą Stronę w ramach realizacji niniejszej umowy, ograniczenia wynikające z niniejszego paragrafu nie znajdą zastosowania i działanie takie nie będzie rodziło po stronie Strony ujawniającej informacje żadnej odpowiedzialności.</li>
<li>Strony zobowiązują się chronić opisane w niniejszym paragrafie informacje poufne w okresie realizacji niniejszej umowy, a także w okresie 36 (trzydziestu sześciu) miesięcy po jej rozwiązaniu lub wygaśnięciu.</li>
<li>W przypadku naruszenia zobowiązań wynikających z niniejszego paragrafu Strona naruszająca zapłaci na żądanie drugiej Strony karę umowną w kwocie 20 000,00 zł (słownie: dwadzieścia tysięcy złotych).</li>
<li>Zastrzeżenie wyżej wymienionej kary umownej nie wyklucza dochodzenia odszkodowania przenoszącego w/w kary umownej.<span class="pageNum" style="margin-top: 10px;">3 z 11</span></li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8 Zgoda na wykorzystanie wizerunku</strong>
</p>
  <ol>
    <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy. Wizerunek będzie wykorzystywany przez Zleceniodawcę w związku z wykonywaniem zleconych zadań określonych w § 1 w celu zapewnienia najwyższych standardów obsługi klienta. Zgoda na wykorzystanie wizerunku stanowi załącznik do niniejszej umowy.</li>
  <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9 Rozwiązanie umowy
</strong>
</p>
<ol>
  <li>Niniejsza umowa może być rozwiązana przez każdą ze stron z zachowaniem [okresWypowiedzenia] okresu wypowiedzenia.</li>
  <li>Zleceniodawca ma prawo do rozwiązania niniejszej umowy ze skutkiem natychmiastowym w razie naruszenia przez Zleceniobiorcę postanowień niniejszej umowy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10 Doręczenia i korespondencja</strong>
</p>
<ol>
  <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy tradycyjne podane w oznaczeniu stron,  uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
  <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 11 Spory i sąd właściwy</strong>
</p>
<p>
 Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 (czternastu) dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.
</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 12 Kompletność oraz zmiana umowy</strong>
</p>
<ol>
  <li>Umowa niniejsza rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
  <li>Strony oświadczają, że poza niniejszą umowa nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
  <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
  <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 13 Klauzula salwatoryjna</strong>
</p>
<p>
Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.<span class="pageNum" style="margin-top: 50px;">4 z 11</span></p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 14 Prawo właściwe</strong>
</p>
<ol>
  <li>Niniejsza umowa podlega prawu polskiemu.
</li>
  <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 15 Liczba egzemplarzy umowy</strong>
</p>
<p>Umowa niniejsza została sporządzona w 2 (dwóch) jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</p>
<br>

<div>
  <p class="underline">Załączniki:</p>
  <ol>
    <li class="underline">Zgoda na wykorzystanie wizerunku</li>
    <li class="underline">Klauzula informacyjna RODO</li>
    <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
    <li class="underline">Informacja o monitoringu rozmów telefonicznych</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">[zamawiajacy]</span><br>
        <span style="margin-left: 0%;">(Zleceniodawca)</span>
    </div>
    <div class="right-cointainer">
        [imieNazwisko]<br>
        <span style="margin-left: 0%;">(Zleceniobiorca)</span>
    </div>
</div>
<br><br>
<span class="pageNum" style="margin-top: 550px;">5 z 11</span>


 <div style="margin-top:5px;page-break-before: always;">
   <p><strong>Załącznik nr 1. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong></p>
   <p>Niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore Poland) zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego wizerunku w formie fotografii w związku z wykonywaniem umowy zlecenia w celu umieszczenia jej w firmowej stopce mailowej. Wizerunek będzie wykorzystywany wyłącznie na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy.</p>
   <p>Jak również niniejszym oświadczam, że udzielam Tutore Poland zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego głosu lub wypowiedzi utrwalonych w trakcie wykonywania niniejszej umowy o świadczenie usług przy użyciu telefonów o połączeniu VoIP (Voice over Internet Protocol).</p>
   <p>Niniejsza  zgoda  obejmuje  następujące  pola  eksploatacji:  wykorzystanie,  utrwalanie, obróbkę  i  powielanie  wykonanych  zdjęć/nagrań,  obrót  egzemplarzami,  na  których  utrwalono mój wizerunek lub głos oraz na zwielokrotnianie wizerunku/głosu wszelkimi dostępnymi technikami i metodami, rozpowszechnianie   oraz   publikowanie,   w   materiałach służących   działalności Tutore Poland w szczególności w materiałach szkoleniowych, edukacyjnych i promocyjnych w dowolnej formie.</p>
   <p>Tutore Poland przysługuje wyłączne prawo decydowania o formie i czasie wykorzystywania mojego wizerunku, głosu, wypowiedzi w całości lub w postaci dowolnych fragmentów. Wizerunek może być użyty do różnego rodzaju form elektronicznego przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku akceptacji produktu końcowego, lecz nie w formach obraźliwych lub ogólnie uznanych za nieetyczne.</p>
   <span class="pageNum" style="margin-top: 495px;">6 z 11</span>
   <div style="page-break-before: always;">
  <p><strong>Załącznik nr 2. KLAUZULA INFORMACYJNA</strong></p>
  <p>Klauzule informacyjne z art. 13 RODO</p>
  <p> Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z 04.05.2016, str. 1), dalej „RODO”, informuję, że:</p>
  <p>Administratorem Pani/Pana danych osobowych jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, zwany dalej: „ADO”.</p>
  <p>Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail kadry@tutore.eu </p>
  <p>ADO przetwarza dane osobowe w celu:</p>
  <ol type="a">
    <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>zapewnienia kontaktu pomiędzy Stronami (adres  e – mail, nr telefonu) - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji praw i obowiązków wynikających z umowy o świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,</li>
    <li>prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c, f RODO,</li>
    <li>ewidencji przebiegu współpracy (w tym realizacja płatności) - Art. 6 ust. 1 lit. b, c RODO,</li>
    <li>dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c RODO,</li>
  </ol>
  <br>
  <p>Odbiorcami danych osobowych są podmioty, którym ADO powierzył przetwarzanie danych osobowych, w szczególności: dostawcy usług technicznych i organizacyjnych, dostawcy usług księgowych, kadrowych, prawnych i doradczych, banki (realizacja płatności), organy publiczne w ramach realizacji obowiązków związanych z prowadzeniem działalności gospodarczej przez ADO. </p>
  <p>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
  <p>Dane osobowe przechowywane będą przez okres realizacji umowy, a następnie przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa, w tym w szczególności: dochodzenie roszczeń (okres przedawnienia roszczeń), prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5 lat od końca roku kalendarzowego, w którym powstał obowiązek podatkowy).</p>
  <p>Osoba, której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</p>
  <p>Podanie przez Panią/Pana danych osobowych oraz zgoda na ich przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne, ale stanowi warunek konieczny dla nawiązania współpracy i ewentualnego zawarcia umowy w formie pisemnej oraz realizacji praw i obowiązków przez ADO.</p>
  <p>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
  <p>Zakres danych podlegający przetwarzaniu: imię i nazwisko, adres mailowy, numer telefonu, wizerunek, PESEL.<span class="pageNum" style="margin-top: 45px;">7 z 11</span></p>
  </div>
  </div>

  <div style="margin-top:5px;page-break-before: always;">
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[data]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[imieNazwisko]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[pesel]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[nrDowodu]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[nrTelefonu]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[email]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres zamieszkania</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>[zamieszkany]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres korespondencyjny</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[korespondencyjny]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Urząd Skarbowy <br>(zgodny z adresem zamieszkania)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>[urzadSkarbowy]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[nrRachunku]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[emeryt]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[rencista]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[orzeczenieNiepelnosprawnosc]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[stopienNiepelnosprawnosci]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia<br>(jeśli wpisano "TAK", proszę pominąć pkt. 5,6,7)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[student]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe<br>(tylko w przypadku objęcia ubezpieczeniem emerytalnym i rentowym)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[chorobowe]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[zatrudnionyUmowaPraca]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[nazwaUmowaPraca]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie<br>jest wyższe bądź równe krajowej płacy minimalnej</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[wynagrodzenieUmowaPraca]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa o pracę i/lub umowa cywilno-prawna z Tutore Poland Sp. z o.o.</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[ubezpieczenieUmowaPraca]</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>[tytulUbezpieczenieUmowaPraca]</span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span><strong>
  Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  Zobowiązuję się do poinformowania Pracodawcy w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany. Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji w Oświadczeniu Zleceniobiorcy, celem wysyłki rocznych deklaracji rozliczeniowych.
  <br/>
  </strong></span></p>
  </td>
  </tr>

  </tbody>
  </table>
  </div>
  <span class="pageNum" style="margin-top: 70px;">8 z 11</span>

<div style="page-break-before: always; font-size: 10px;">
<p align="center" class="subheading" style="margin-bottom: 0px;">
  <strong>
    Upoważnienie<br>
    do przetwarzania danych osobowych w zbiorze w wersji<br>
    papierowej i elektronicznej
  </strong>
</p>
<p>&nbsp;</p>
<p>
  <span>
    Niniejszym upoważniam Pana/Panią [imieNazwisko]
    do przetwarzania danych osobowych zawartych 
    w poniżej wymienionych zbiorach danych osobowych 
    w wersji papierowej i elektronicznej:
  </span>
</p>
<p>
<ul>
  <li>
    zbiór danych osobowych:dzieci uczestniczących w zajęciach organizowanych przez Tutore Poland Sp. z o.o.
  </li>
  <li>
    zbiór danych osobowych: rodziców (opiekunów prawnych) dzieci uczestniczących w zajęciach organizowanych przez Tutore Poland Sp. z o.o.
  </li>
</ul>
</p>
<p><span>w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami. </span></p>
<p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
</p>
<p>
  Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
</p>

<p>
Upoważnienie jest ważne do odwołania.
</p>

<p style="font-style: italic;">
  Oświadczam, iż zapoznałem się z przepisami dotyczących ochrony danych osobowych, w szczególności Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) oraz wdrożonymi obowiązkami związanymi z obowiązującą w Tutore Poland Sp. z o.o. Polityką prywatności dot. przetwarzania danych osobowych.
</p>
<p style="font-style: italic;">
  Zobowiązuję się do przestrzegania w/w zasad oraz do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
</p>
<p style="font-style: italic;">
  Podpis osoby upoważnionej: <span style="font-size: 12px">[imieNazwisko]</span>
  <p align="center" class="subheading" style="margin-bottom: 0px;">
  
  </p>
  <span class="pageNum" style="margin-top: 420px;">9 z 11</span>
  </div>

  <div style="page-break-before: always;">
  <strong>Informacja o monitoringu rozmów telefonicznych</strong>
  <br>
Informujemy, iż Tutore Poland Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring rozmów telefonicznych prowadzonych z klientami firmy, w ramach prowadzonej obsługi telefonicznej. Monitoringiem są objęte telefony o połączeniu VoIP (Voice over Internet Protocol) znajdujące się w siedzibie Tutore Poland Sp. z o.o.. Tutore Poland Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów jakości obsługi klienta, szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa pracownikom/zleceniobiorcom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony klientów (np. groźby karalne). Informujemy, iż: system monitoringu rozmów telefonicznych składa się z systemu rejestrującego rozmowę telefoniczną na telefonach typu VoIP oraz serwera, dostęp do zapisu nagrań rozmów telefonicznych w ramach firmy posiada wyłącznie Manager Działu Call Center oraz Zarząd, osoby, które mają wgląd do zarejestrowanych nagrań mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu oraz ewentualnie imienia i nazwiska pracownika/zleceniobiorcy. Administratorem danych osobowych uzyskanych na nagraniach monitoringu rozmów telefonicznych jest Tutore Poland Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych. 
<br>
<br>
<strong>Klauzula informacyjna Tutore Poland Sp. z o.o. dla pracowników/zleceniobiorców w związku z przetwarzaniem danych osobowych w ramach monitoringu rozmów telefonicznych</strong>
<br>
Na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, Tutore Poland Sp. z o.o. informuje:
<ol>
<li>Administratorem Danych Osobowych jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, tel. 535 933 870 info@tutore.eu, dalej ADO.</li> 
<li>ADO przetwarza dane osobowe dla celach wskazanych w informacji o monitoringu rozmów telefonicznych – podstawę prawną przetwarzania stanowi uzasadniony interes administratora (art. 6 ust. 1 lit. f RODO).</li>
<li>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</li>
<li>Dane osobowe przechowywane będą przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub ADO powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu.</li>
<li>Odbiorcami danych osobowych mogą być organy publiczne, organy wymiaru sprawiedliwości, jednostki świadczące na rzecz ADO usługi doradcze (w szczególności doradztwo prawne).</li>
<li>Osoba której dane są przetwarzane ma prawo:</li>
<ol type="a"> 
<li>dostępu do swoich danych oraz otrzymania ich kopii,</li>
<li>prawo do sprostowania (poprawiania) swoich danych,</li> 
<li>prawo do ograniczenia przetwarzania,</li> 
<li>prawo do bycia zapomnianym,</li> 
<li>prawo do sprzeciwu,</li> 
<li>prawo do przenoszenia danych,</li> 
<li>prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</li>
</ol>
<li>Podanie danych osobowych w zakresie objętym klauzulą jest całkowicie dobrowolne, ale niezbędne dla realizacji celu przetwarzania.</li>
<li>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</li><span class="pageNum" style="margin-top: 7px;">10 z 11</span>
</ol>
</div>


<div style="page-break-before: always;">
  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 14px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE PRACOWNIKA/ZLECENIOBIORCY</strong></p>
        Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>zapoznałem/am się z Informacją o monitoringu rozmów telefonicznych oraz Klauzulą Informacyjną i przyjmuję ją do wiadomości,</li>
          <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
          </ol>
          <br>
          <div class="right-cointainer" style="float: right;">
        [imieNazwisko]
        <br>
        <span>czytelny podpis Pracownika/Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>
  <span class="pageNum" style="margin-top: 700px;">11 z 11</span>
  </div>

  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
import UmowaMonitoring from './UmowaMonitoring'

export default {
  name: 'UmowaGitara',
  components: {
    UmowaMonitoring
  },
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrumowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      shortUmowa: '',
      wypoSlownie: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      tab = this.nrumowy.split('/')
      this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/CC`
      return this.shortUmowa
    },
    okresWypo () {
      switch (this.wypo) {
        case '5 dni':
          this.wypoSlownie = '5-dniowego'
          break
        case 'tydzień':
          this.wypoSlownie = 'tygodniowego'
          break
        case '2 tygodnie':
          this.wypoSlownie = 'dwutygodniowego'
          break
        case '1 miesiąc':
          this.wypoSlownie = 'miesięcznego'
          break
      }
      return this.wypoSlownie
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
#oswiadczenie {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/WzorUmowaKonsultantCC.vue